/**
 * PanchTatvaButton
 * variant: 'primary' (default) | 'outline' | 'ghost'
 * size:    'default' (default) | 'small' | 'large'
 * fullWidth: boolean
 */
export default function PanchTatvaButton({
  children,
  onClick,
  className = '',
  type = 'button',
  variant = 'primary',
  size = 'default',
  fullWidth = false,
}) {
  const base = 'font-semibold rounded-lg transition-all duration-300 whitespace-nowrap focus:outline-none';

  const variants = {
    primary: 'bg-secondary text-white hover:opacity-90',
    outline: 'border-2 border-secondary text-secondary bg-transparent hover:bg-secondary hover:text-white',
    ghost:   'text-secondary bg-transparent hover:bg-secondary/10',
  };

  const sizes = {
    small:   'px-3 py-1.5 text-xs md:text-sm',
    default: 'px-4 md:px-6 py-2 md:py-3 text-sm md:text-base',
    large:   'px-6 md:px-8 py-3 md:py-4 text-base md:text-lg',
  };

  return (
    <button
      type={type}
      onClick={onClick}
      className={`${base} ${variants[variant] ?? variants.primary} ${sizes[size] ?? sizes.default} ${fullWidth ? 'w-full' : ''} ${className}`}
    >
      {children}
    </button>
  );
}
